import { Main } from "./main";

Main.init();
